import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "./../component/Header";
import Sidebar from "./../component/Sidebar"; // Corrected the component name here

const EditIcon = require("./../assets/img/edit-icon.svg").default;
const viewIcon = require("./../assets/img/eye-icon.svg").default;
const searchIcon = require("./../assets/img/search-icon.svg").default;
const removeIcon = require("./../assets/img/remove-icon.svg").default;

const Trash = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [userData, setUserData] = useState(null);
  const [searchKey, setSearchKey] = useState("");
  const [pageNumber, setPageNumber] = useState("1");
  const filesPerPage = 5; // Number of files to display per page
  const [totalRecord, setTotalRecord] = useState(0);
  const [fileData, setFileData] = useState([]);
  const [pageLimit, setPageLimit] = useState("5");
  const [timer, setTimer] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [fileToRemove, setFileToRemove] = useState(null);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [showAllConfirmationModal, setAllShowConfirmationModal] =
    useState(false);
  const [showRestoreConfirmationModal, setShowRestoreConfirmationModal] =
    useState(false);
  const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);

  const handleCheckboxChange = (event, fileName) => {
    const checked = event.target.checked;
    if (checked) {
      setSelectedFiles((prevSelectedFiles) => [...prevSelectedFiles, fileName]);
    } else {
      setSelectedFiles((prevSelectedFiles) =>
        prevSelectedFiles.filter((file) => file !== fileName)
      );
    }
  };

  const delayExecution = (callback, ms) => {
    clearTimeout(timer);
    const newTimer = setTimeout(callback, ms);
    setTimer(newTimer);
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    setPageNumber(pageNumber);
    formDataSubmit(pageNumber, searchKey);
  };

  const handleSearchChange = (event) => {
    setSearchKey(event.target.value);

    delayExecution(() => {
      formDataSubmit(pageNumber, event.target.value);
    }, 500);
  };

  const fetchAllFiles = (storedUserData) => {
    formDataSubmit(pageNumber, searchKey);
  };

  const formDataSubmit = (pageNumber, searchKey) => {
    const storedUserData = JSON.parse(localStorage.getItem("userData"));

    // Construct the URL with from_date and to_date parameters
    const form = new FormData();
    form.append("search_key", searchKey);
    form.append("page_no", pageNumber);
    form.append("limit", pageLimit);

    fetch(`https://cliqestimatebuilder.com/waiver_admin/forms/trash`, {
      headers: {
        Authorization: `Bearer ${storedUserData.token}`,
      },
      method: "POST",
      body: form,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.data && Array.isArray(data.data)) {
          setFileData(data.data);

          // Check if totalRecord exists in the data object
          if ("totalRecord" in data) {
            setTotalRecord(data.totalRecord);
          } else {
            setTotalRecord(0); // Set totalRecord to 0 if it's not present in response
          }
        } else {
          setFileData([]);
          setTotalRecord(0);
          console.error("Received data is not in the expected format:", data);
        }
      })
      .catch((error) => console.error("Error fetching file data:", error));
  };

  const handleSearchSubmit = (event) => {
    event.preventDefault();
    setCurrentPage(1); // Reset to the first page
    formDataSubmit(pageNumber, searchKey);
  };

  const handleRemoveClick = (index, fileId) => {
    setFileToRemove({ index, fileId });
    setShowConfirmationModal(true);
  };

  const handleAllRemoveClick = (index, fileId) => {
    setAllShowConfirmationModal(true);
  };

  const handleRestoreClick = (index, fileId) => {
    setFileToRemove({ index, fileId });
    setShowRestoreConfirmationModal(true);
  };

  const deleteFile = () => {
    if (fileToRemove) {
      const { index, fileId } = fileToRemove;
      const storedUserData = JSON.parse(localStorage.getItem("userData"));

      // Remove the table row when the button is clicked
      const updatedFileData = [...fileData];
      updatedFileData.splice(index, 1);

      setFileData(updatedFileData);

      const formData = new FormData();
      formData.append("id", fileId);

      fetch(`https://cliqestimatebuilder.com/waiver_admin/forms/${fileId}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${storedUserData.token}`,
        },
        body: formData,
      })
        .then((response) => response.json())
        .then((data) => {
          console.log(data);
          if (data.res === 1) {
            // File successfully deleted
            setSelectedFiles([]);
            fetchAllFiles(storedUserData);
          } else {
            if (data.error) {
              console.error("Error deleting file:", data.error);
              // Handle the error condition if required
            } else {
              console.error("Error deleting file: Unknown error");
              // Handle other types of errors
            }
          }
        })
        .catch((error) =>
          console.error("Error changing delete status:", error)
        );

      setShowConfirmationModal(false);
      setFileToRemove(null);
    }
  };

  const restoreFile = () => {
    if (fileToRemove) {
      const { index, fileId } = fileToRemove;
      const storedUserData = JSON.parse(localStorage.getItem("userData"));

      // Remove the table row when the button is clicked
      const updatedFileData = [...fileData];
      updatedFileData.splice(index, 1);

      setFileData(updatedFileData);

      const formData = new FormData();
      formData.append("id", fileId);

      fetch(
        `https://cliqestimatebuilder.com/waiver_admin/forms/restore/${fileId}`,
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${storedUserData.token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          console.log(data);
          if (data.res === 1) {
            // File successfully deleted
            setSelectedFiles([]);
            fetchAllFiles(storedUserData);
          } else {
            if (data.error) {
              console.error("Error deleting file:", data.error);
              // Handle the error condition if required
            } else {
              console.error("Error deleting file: Unknown error");
              // Handle other types of errors
            }
          }
        })
        .catch((error) =>
          console.error("Error changing delete status:", error)
        );

      setShowRestoreConfirmationModal(false);
      setFileToRemove(null);
    }
  };

  const handleSelectAll = () => {
    // If all checkboxes are currently checked, deselect all; otherwise, select all
    if (selectedFiles.length === fileData.length) {
      setSelectedFiles([]);
    } else {
      setSelectedFiles(fileData.map((file) => file.id));
    }
  };

  const handleDeleteSelected = () => {
    if (selectedFiles.length === 0) {
      // No files selected, do nothing
      return;
    }

    // Show a confirmation modal or alert to confirm deletion

    // For now, let's assume a confirmation is received

    const storedUserData = JSON.parse(localStorage.getItem("userData"));

    // Remove the table rows corresponding to the selected files
    const updatedFileData = fileData.filter(
      (file) => !selectedFiles.includes(file.id)
    );

    setFileData(updatedFileData);

    const formData = new FormData();
    selectedFiles.forEach((fileId) => {
      formData.append("form_ids[]", fileId); // Use [] to create an array of IDs
    });

    fetch(`https://cliqestimatebuilder.com/waiver_admin/forms/`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${storedUserData.token}`,
      },
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        if (data.res == 1) {
          // Files successfully deleted
          setAllShowConfirmationModal(false);
          setSelectedFiles([]);
          fetchAllFiles(storedUserData);
        } else {
          if (data.error) {
            console.error("Error deleting files:", data.error);
            // Handle the error condition if required
          } else {
            console.error("Error deleting files: Unknown error");
            // Handle other types of errors
          }
        }
      })
      .catch((error) => console.error("Error deleting files:", error));
  };

  const showPagination = Math.ceil(totalRecord / filesPerPage);

  const totalPages = Math.ceil(totalRecord / filesPerPage);

  useEffect(() => {
    const storedUserData = JSON.parse(localStorage.getItem("userData"));
    setUserData(storedUserData);

    fetchAllFiles(storedUserData);
  }, []);

  return (
    <div className="bodyMain">
      <div className="sideBar">
        <Sidebar />
      </div>

      <div className="contentDiv">
        <Header userData={userData} />

        <div className="mainContent">
          <div className="viewBox">
            <div className="topSearch">
              <div className="searchSec">
                <h2>All Files</h2>

                <div className="rgtSearch">
                  <form onSubmit={handleSearchSubmit}>
                    <input
                      type="search"
                      placeholder="Search here"
                      value={searchKey}
                      onChange={(e) => handleSearchChange(e)}
                    />
                    <button type="submit">
                      <img src={searchIcon} alt="" />
                    </button>
                  </form>
                </div>
              </div>
            </div>
            <div className="viewFileList">
              <h3 className="ttlFrms">Total {totalRecord} forms</h3>
              <div className="trashBtns">
                <button
                  type="submit"
                  className="delAll"
                  onClick={handleAllRemoveClick}
                >
                  Delete Selected
                </button>
                <button
                  type="submit"
                  className="slctAll"
                  onClick={handleSelectAll}
                >
                  Select All
                </button>
              </div>
              <div className="tshTble">
                <table>
                  <thead>
                    <tr>
                      <th></th>
                      <th>Name</th>
                      <th>Create On</th>
                      <th>Last Updated</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  {fileData?.length > 0 ? (
                    <tbody>
                      {fileData.map((file, index) => (
                        <tr
                          key={index}
                          className={
                            selectedFiles.includes(file.id) ? "active" : ""
                          }
                        >
                          <td className="checkWidth">
                            <input
                              type="checkbox"
                              checked={selectedFiles.includes(file.id)}
                              onChange={(event) =>
                                handleCheckboxChange(event, file.id)
                              }
                            />
                          </td>
                          {/* <td className="countWidth">{index + 1}</td> */}
                          <td className="formName">{file.form_name}</td>
                          <td>{file.created_at}</td>
                          <td>{file.updated_at}</td>
                          <td
                            className={
                              Number(file.status) === 0
                                ? "status"
                                : Number(file.status) === 1
                                ? "signedBtn"
                                : Number(file.status) === 2
                                ? "status cancelledBtn"
                                : null
                            }
                          >
                            {Number(file.status) === 0
                              ? "Created"
                              : Number(file.status) === 1
                              ? "Signed"
                              : Number(file.status) === 2
                              ? "Cancelled"
                              : null}
                          </td>
                          <td className="btnsWidth">
                            {selectedFiles.includes(file.id) ? (
                              <Link
                                to=""
                                className="createBtn restoreBtn"
                                onClick={() =>
                                  handleRestoreClick(index, file.id)
                                }
                              >
                                Restore
                              </Link>
                            ) : null}

                            <button>
                              <Link
                                to=""
                                onClick={() =>
                                  handleRemoveClick(index, file.id)
                                }
                              >
                                <img src={removeIcon} alt="" />
                              </Link>
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  ) : (
                    <tr>
                      <td colSpan={6} className="clsPan">
                        <span class="lgnStatus">Files Not Found</span>
                      </td>
                    </tr>
                  )}
                  {showConfirmationModal ? (
                    <div className="confirmation-modal">
                      <div className="modal-content">
                        <p>Are you sure you want to remove this file?</p>
                        <div className="modal-buttons">
                          <button onClick={() => deleteFile()}>Yes</button>
                          <button
                            onClick={() => setShowConfirmationModal(false)}
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  ) : null}
                  {showRestoreConfirmationModal ? (
                    <div className="confirmation-modal">
                      <div className="modal-content">
                        <p>Are you sure you want to restore this file?</p>
                        <div className="modal-buttons">
                          <button onClick={() => restoreFile()}>Yes</button>
                          <button
                            onClick={() =>
                              setShowRestoreConfirmationModal(false)
                            }
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  ) : null}
                  {showAllConfirmationModal ? (
                    <div className="confirmation-modal">
                      <div className="modal-content">
                        <p>Are you sure you want to delete all files?</p>
                        <div className="modal-buttons">
                          <button onClick={() => handleDeleteSelected()}>
                            Yes
                          </button>
                          <button
                            onClick={() => setAllShowConfirmationModal(false)}
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  ) : null}
                </table>
              </div>

              {/* <div className="listing trshTable">
                <table>
                  <thead>
                    <tr>
                      <th></th>
                      <th>Name</th>
                      <th>Create On</th>
                      <th>Last Updated</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      className={
                        selectedFiles.includes("Form-1") ? "active" : ""
                      }
                    >
                      <td className="checkWidth">
                        <input
                          type="checkbox"
                          onChange={(event) =>
                            handleCheckboxChange(event, "Form-1")
                          }
                        />
                      </td>
                      <td className="formName">Form-1</td>
                      <td>05 July, 2023</td>
                      <td>17 July, 2023</td>
                      <td className="signedBtn">Signed</td>
                      <td className="btnsWidth">
                        {selectedFiles.includes("Form-1") ? (
                          <Link to="" className="createBtn restoreBtn">
                            Restore
                          </Link>
                        ) : null}

                        <button>
                          <Link to="">
                            <img src={removeIcon} alt="View" />
                          </Link>
                        </button>
                      </td>
                    </tr>
                    <tr
                      className={
                        selectedFiles.includes("Form-2") ? "active" : ""
                      }
                    >
                      <td className="checkWidth">
                        <input
                          type="checkbox"
                          onChange={(event) =>
                            handleCheckboxChange(event, "Form-2")
                          }
                        />
                      </td>
                      <td className="formName">Form-2</td>
                      <td>05 July, 2023</td>
                      <td>17 July, 2023</td>
                      <td className="signedBtn">Signed</td>
                      <td className="btnsWidth">
                        {selectedFiles.includes("Form-2") ? (
                          <Link to="" className="createBtn restoreBtn">
                            Restore
                          </Link>
                        ) : null}

                        <button>
                          <Link to="">
                            <img src={removeIcon} alt="View" />
                          </Link>
                        </button>
                      </td>
                    </tr>
                    <tr
                      className={
                        selectedFiles.includes("Form-3") ? "active" : ""
                      }
                    >
                      <td className="checkWidth">
                        <input
                          type="checkbox"
                          onChange={(event) =>
                            handleCheckboxChange(event, "Form-3")
                          }
                        />
                      </td>
                      <td className="formName">Form-3</td>
                      <td>05 July, 2023</td>
                      <td>17 July, 2023</td>
                      <td className="signedBtn">Signed</td>
                      <td className="btnsWidth">
                        {selectedFiles.includes("Form-3") ? (
                          <Link to="" className="createBtn restoreBtn">
                            Restore
                          </Link>
                        ) : null}

                        <button>
                          <Link to="">
                            <img src={removeIcon} alt="View" />
                          </Link>
                        </button>
                      </td>
                    </tr>
                    <tr
                      className={
                        selectedFiles.includes("Form-4") ? "active" : ""
                      }
                    >
                      <td className="checkWidth">
                        <input
                          type="checkbox"
                          onChange={(event) =>
                            handleCheckboxChange(event, "Form-4")
                          }
                        />
                      </td>
                      <td className="formName">Form-4</td>
                      <td>05 July, 2023</td>
                      <td>17 July, 2023</td>
                      <td className="signedBtn">Signed</td>
                      <td className="btnsWidth">
                        {selectedFiles.includes("Form-4") ? (
                          <Link to="" className="createBtn restoreBtn">
                            Restore
                          </Link>
                        ) : null}

                        <button>
                          <Link to="">
                            <img src={removeIcon} alt="View" />
                          </Link>
                        </button>
                      </td>
                    </tr>
                    <tr
                      className={
                        selectedFiles.includes("Form-5") ? "active" : ""
                      }
                    >
                      <td className="checkWidth">
                        <input
                          type="checkbox"
                          onChange={(event) =>
                            handleCheckboxChange(event, "Form-5")
                          }
                        />
                      </td>
                      <td className="formName">Form-5</td>
                      <td>05 July, 2023</td>
                      <td>17 July, 2023</td>
                      <td className="signedBtn">Signed</td>
                      <td className="btnsWidth">
                        {selectedFiles.includes("Form-5") ? (
                          <Link to="" className="createBtn restoreBtn">
                            Restore
                          </Link>
                        ) : null}

                        <button>
                          <Link to="">
                            <img src={removeIcon} alt="View" />
                          </Link>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div> */}
            </div>

            {showPagination ? (
              <div className="paginationDiv">
                <ul>
                  {Array.from({ length: totalPages }, (_, index) => (
                    <li key={index}>
                      <Link
                        to="#"
                        className={currentPage === index + 1 ? "active" : ""}
                        onClick={() => handlePageChange(index + 1)}
                      >
                        {index + 1}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Trash;
